if((typeof $ == 'function') && $.behavior) {
  $.behavior('Groupon.AnalyticsEventTracking', {
    _init: function() {
      this.trackOnClick = !$(this.element).hasClass('trackNow');

      if (!this.trackOnClick) {
        this._track('trackLoad');
      }
    },

    click: function(e) {
      if (!this.trackOnClick) { return; }
      this._track('trackClick');
    },

    _track: function(eventType) {
      if (this.element.attr("data-google-analytics-tags")) {
        this._doTrack(eventType, this.element.attr("data-google-analytics-tags").split(" "));
      }

      _.each($(this.element).attr('class').split(/\s/), _.bind(function(classname) {
        if (classname.indexOf("E-") !== -1) {
          this._doTrack(eventType, classname.replace("E-","").split("_"));
        }
      }, this));
    },

    _doTrack: function(eventType, params) {
      Groupon.Analytics[eventType].apply(Groupon.Analytics, this._constructParams(params));
    },

    _constructParams: function(params) {
      for (var i = 0; i < 3; i++) {
        params[i] = params[i] || " ";
      }
      return params;
    }
  });

  $.widget('Groupon.AnalyticsPixelTracking', {
    commonAttrs: ['event', 't'],

    _init: function() {
      var $el= $(this.element);
      this.data = _($el.data('track')).clone();
      this._writeCommonAttributes();

      if(this._trackOnRender())
        this._injectPixel(this.t, this.data);

      else if(this.event)
        $el.bind(this.event, function(e) {
          this._injectPixel(this.t, _(this.data).extend({runOnLoad: true}));
        }.bind(this));
    },

    _injectPixel: function(type, params) {
      Groupon.Analytics.PixelTracker.injectTrackingPixel(type, params);
    },

    _trackOnRender: function() {
      return this.event == 'render';
    },

    _writeCommonAttributes: function() {
      _(this.commonAttrs).each(_(function(attr, i) {
        this[attr] = this.data[attr];
        delete this.data[attr];
      }).bind(this));
    }
  });

  $(function() {
    $('.G_event').AnalyticsEventTracking();
    $('[data-track]').AnalyticsPixelTracking();
    Groupon.Analytics.PixelTracker.injectTrackingPixelFromCookie();
  });
}
